import { render, staticRenderFns } from "./Regstock.vue?vue&type=template&id=8098b362&scoped=true&"
import script from "./Regstock.vue?vue&type=script&lang=js&"
export * from "./Regstock.vue?vue&type=script&lang=js&"
import style0 from "./Regstock.vue?vue&type=style&index=0&id=8098b362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8098b362",
  null
  
)

component.options.__file = "Regstock.vue"
export default component.exports